export default __webpack_public_path__ + "static/media/aro-img.4a1b0329.jpeg";